import types from './types'
import {encryption,generateCodeVerifier} from '@/util/utils';
import {loginByUsername,bpmnSecurityLogin, LoginWithoutPwd, loginByUsernameSsO} from '@/api/login';
import {fetchDeptTree,fetchScopeDeptTree, studentTreeUrl} from '@/api/admin/dept';
import {getUserPermissions} from '@/api/admin/user';
import {fetchMenuTree, GetMenu} from '@/api/admin/menu'
import {getPageDeskVo} from '@/api/home/home'
import {
    unreadCount
} from '@/api/bpmnApi/bpmn';
// 全局方法
export default {
  setUserToken: ({ commit, state }, value) => {
    commit(types.SET_USER_DTOKEN, value)
  },
  setUserData: ({ commit, state }, value) => {
    commit(types.SET_USER_DATA, value)
  },
  setAccessToken: ({ commit, state }, value) => {
    commit(types.SET_ACCESS_DTOKEN, value)
  },
  logout: ({ commit, state }) => {
    commit(types.LOGIN_OUT)
  },
  changeTheme: ({ commit, state }, value) => {
    commit(types.CHANGE_THEME, value)
  },
  editNode({commit, state}, params) {
    commit("setStatus", "edit");
    commit("setFormTitle");
    commit("setFormData", params.data);
    commit("setDialog");
    return new Promise((resolve, reject) => {
      resolve(111);
    });
  },
  appendNode({commit, state}, params) {
    commit("setStatus", "add");
    commit("setFormTitle");
    commit("clearForm");
    commit("setDialog");
    return new Promise((resolve, reject) => {
      resolve(222);
    });
  },
  closeDialog({commit}) {
    commit("setDialog");
  },
  submitForm({commit, state}, params) {
    return new Promise((resolve, reject) => {
      resolve(params);
    });
  },
  // 根据用户名登录
  LoginByUsername({commit}, userInfo) {
    const user = encryption({
      data: userInfo,
      key: '1234567812345678',
      param: ['password']
    });
    return new Promise((resolve, reject) => {
      loginByUsername(user.username, user.password, user.code, user.randomStr, generateCodeVerifier(5)).then(response => {
        const data = response.data;
        if (data) {
          commit('SET_ACCESS_TOKEN', data.access_token);
          localStorage.token = data.access_token;
          commit('SET_LOG_MSG', data);
          resolve(response)
        } else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 免密登录
  LoginWithoutPwd({commit}, userInfo) {
    return new Promise((resolve, reject) => {
      LoginWithoutPwd(userInfo.username).then(response => {
        const data = response.data;
        if (data) {
          commit('SET_ACCESS_TOKEN', data.access_token);
          localStorage.token = data.access_token;
          commit('SET_LOG_MSG', data);
          resolve(response)
        } else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
    // 根据SsO的，迈越单点登录
    LoginByUsernameSSO({commit}, code) {
        let data = {
            grant_type : 'maiyuesso',
            // client_id: 'test',
            // client_secret: 'test',
            code: code
        }
        return new Promise((resolve, reject) => {
            loginByUsernameSsO(code).then(response => {
                const data = response.data;
                if (data) {
                    commit('SET_ACCESS_TOKEN', data.access_token);
                    localStorage.token = data.access_token;
                    commit('SET_LOG_MSG', data);
                    resolve(response)
                } else {
                    reject(error)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
  // 获取部门树数据
  getDeptTree({commit}) {
    return new Promise((resolve, reject) => {
      fetchDeptTree().then(response => {
        const data = response.data;
        if(data){
          commit('SET_CHOOSE_DEPT', data.data);
          resolve(response)
        }else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取学生树形数据
  getStudentTree ({commit}) {
    let _this = this
    return new Promise((resolve, reject) => {
      studentTreeUrl().then(response => {
        const data = response.data;
        if(data){
          commit('SET_STUDENT_TREE', data.data);
          resolve(response)
        }else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户管辖部门树数据
  GetUserPermissions({commit}) {
    return new Promise((resolve, reject) => {
      getUserPermissions().then(response => {
        const data = response.data;
        if (data) {
          commit('SET_PERMISSIONS', data.data.permissions || []);
          resolve(response.data)
        } else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取权限菜单
  GetNewUserMenu({commit}) {
    return new Promise((resolve, reject) => {
      fetchMenuTree().then(response => {
        const data = response.data;
        if (data) {
          commit('SET_NEW_MENU', data.data);
          resolve(response.data)
        } else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户菜单
  GetUserMenu({commit}) {
    return new Promise((resolve, reject) => {
      GetMenu().then(response => {
        const data = response.data;
        if (data) {
          commit('SET_MENU', data.data);
          resolve(response.data)
        } else {
          reject(error)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPageDeskVo({commit}, deskId){
    let obj = {};
    if(deskId){
      obj.deskId = deskId || '';
    }
    return new Promise((resolve, reject) => {
      getPageDeskVo(obj).then(({data}) => {
        if(data.code==0){
          commit('setModuleList', data.data.cards || [])
          resolve(data.data.cards)
        }else {
          reject(data.msg)
        }
      })
    })
  },
  // 流程登录状态
  bpmnSecurityLoginHandle({commit},params) {
      return new Promise((resolve, reject) => {
          bpmnSecurityLogin(params).then(({data}) => {
            if(data.code==0){
                 commit('setBpmnSid',data.data.sid);
                 document.cookie=data.data.cookie;
                 resolve()
            }else{
                reject(data)
            }
          }).catch(error => {
              reject(error)
          })
      })
  },
    GetUnreadCount({commit}, deskId){
        return new Promise((resolve, reject) => {
            unreadCount().then(({data}) => {
                if(data.code==0){
                    commit('setUnreadMsgCount', data.data.unreadCount||0)
                    resolve(data)
                }else {
                    reject(data)
                }
            })
        })
    },

  // // 南师大流程登录状态
  // nsdBpmnSecurityLoginHandle({commit},params) {
  //     return new Promise((resolve, reject) => {
  //         bpmnSecurityLogin(params).then(({data}) => {
  //           if(data.code==0){
  //                commit('setBpmnSid',data.data.sid);
  //                document.cookie=data.data.cookie;
  //                resolve()
  //           }else{
  //               reject(data)
  //           }
  //         }).catch(error => {
  //             reject(error)
  //         })
  //     })
  // },
}
